import { adminApiClient } from './adminApiClient';

export const adminNewsletterService = {
  getStats() {
    return adminApiClient.get('/api/newsletter/admin/stats');
  },

  send(subject, content) {
    return adminApiClient.post('/api/newsletter/admin/send', { subject, content });
  },
};
